import { Transaction } from "@iterate/common/types/shared";
import * as React from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { CategorySelect } from "src/components/CategorySelect";
import { trpc } from "src/trpc";
import { useBackButton } from "src/hooks/useBackButton";

export interface Props {
  transaction: Transaction;
  onClose(): void;
}

interface Form {
  categoryId: string | null;
  override: boolean;
}

export function TransactionForm({ transaction, onClose }: Props) {
  useBackButton(onClose);
  const utils = trpc.useUtils();
  const { mutateAsync: updateTransaction } = trpc.updateTransaction.useMutation();
  const [form, setForm] = React.useState<Form>({
    categoryId: transaction.categoryId,
    override: transaction.override,
  });

  const { categoryId, override } = form;

  const setCategory = (categoryId: string | null) => setForm({ ...form, categoryId });

  const toggleOverride = () => setForm({ ...form, override: !override });

  const onSave = async (e: React.FormEvent) => {
    e.preventDefault();
    if (categoryId) {
      await updateTransaction({
        transactionId: transaction.id,
        categoryId,
        override,
      });
      await utils.getTransactions.invalidate();
      await utils.getAggregateSpend.invalidate();
      onClose();
    }
  };

  return (
    <Modal show onHide={onClose}>
      <Form onSubmit={onSave}>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Category</Form.Label>
            <CategorySelect value={categoryId} onChange={setCategory} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Override</Form.Label>
            <Form.Check checked={override} onChange={toggleOverride} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button type="submit">Save Transaction</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}
